import React, { Component } from 'react';


class Header extends Component {


	render() {
		return (
			// className="navbar is-transparent is-fixed-top"
			<div>
			
				<section className="hero is-fullheight" id="header" name="scroll-to-header">
					<div className="hero-body" id="header">
						<div className="container is-fluid">
							<div className="columns is-vcentered ">
								<div className="column  is-half">
									<h1 className="title is-1">Deliv Apps</h1>
									<h4 className="subtitle ">Aplikasi untuk semua kebutuhan hidupmu</h4>
									<a href="https://s.id/31FSI" className="button btn-blue is-rounded is-medium">
										Download
									</a>
									<a href="#feature" className="button is-info is-rounded is-medium is-inverted is-outlined">
										Learn More
									</a>
								</div>
								<div className="column right_image">
									<figure className="image">
										<img
											className=""
											src="/img/deliv_example.png"
											alt="Deliv Example"
											className="header_image"
										/>
									</figure>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		);
	}
}

export default Header;
